import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'

export default function PrivateRoute() {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated)

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />
}